<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [hasDefault]="false"
  [isShowModal]="false"
  [columns]="columns"
  (focus)="focusFunction()"
  (valueChangeByApiName)="onChange($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="ProductConversionDetailColumns && ProductConversionDetailColumns.length > 0">
    <editable-grid
      #grid
      [columns]="ProductConversionDetailColumns"
      [dataList]="model.ProductConversionDetails"
      [isAdd]="!VoucherDeleteable"
      [isEdit]="!VoucherDeleteable"
      [height]="40"
      [DefaultValues]="DefaultValues"
      (valueChanges)="valueChanges($event)"
      aggregatesColumnName="Price,PriceRate,AmountRate,BaseAmount,"
      (formGroupValueChanges)="onformGroupValueChanges($event)"
      [isDelete]="!VoucherDeleteable">
    </editable-grid>
  </ng-container>
  <ng-container class="footer">
    <ssg-button
      *hasPermission="['Inventory:ProductConversionHeader/CreateVoucher', 'Same']"
      icon="icon-file-document-multiple-outline"
      (click)="createVoucher()"
      buttontype="button"
      class="action-btn"
      tooltip="صدور سند"
      [disabled]="!VoucherCreatable">
    </ssg-button>
    <ssg-button
      *hasPermission="['Inventory:ProductConversionHeader/DeleteVucher', 'Same']"
      icon="icon-auto_delete-o"
      (click)="deleteVoucher()"
      buttontype="button"
      class="action-btn"
      tooltip="حذف سند"
      [disabled]="!VoucherDeleteable">
    </ssg-button>
    <ssg-button
      icon="icon-arrow-circle-o-down"
      (click)="getStandardInfo()"
      buttontype="button"
      class="action-btn"
      tooltip="دریافت اطلاعات استاندارد"
      [disabled]="readableStandardInfo">
    </ssg-button>
    <ssg-menu *ngIf="!isNewRow" icon="icon-print-o" class="btnstyle" tooltip="چاپ">
      <ng-container class="menuitem">
        <div>
          <div *ngFor="let report of reportKinds" class="reportbtn">
            <button class="btn" (click)="changeReport(report.value)">{{ report.name }}</button>
          </div>
        </div>
      </ng-container>
    </ssg-menu>
  </ng-container>
</dynamic-form>
